import React, { useCallback } from "react";

import { DataInFreshlyEnteredRow } from "components/PageDashboard/AvailabilitySection/AvailabilityTable/AvailabilityTable";
import { ModalWizardStepRenderProps } from "components/ModalWizard/ModalWizard";
import StepTime from "components/PageDashboard/StepTime";

function StepTimeTo({
	wizardData,
	...rest
}: ModalWizardStepRenderProps<DataInFreshlyEnteredRow>) {
	const { timeFirstAvailableLocaltime } = wizardData;
	const checkDisabled = useCallback(
		time => {
			return timeFirstAvailableLocaltime
				? time <= timeFirstAvailableLocaltime.hours()
				: false;
		},
		[timeFirstAvailableLocaltime]
	);
	return (
		<StepTime
			wizardData={wizardData}
			wizardKey={"timeLastAvailableJustBeforeLocaltime" as any}
			checkDisabled={checkDisabled}
			{...rest}
		/>
	);
}

export default StepTimeTo;
